import { Link } from "react-router-dom";
import { ScrollReveal } from "@/components/base/ScrollAnimations";

const cells = [
  {
    slug: "/cells/textile-engineering",
    name: "Textile Engineering Cell",
    icon: "ri-settings-3-line",
    description: "Machine optimization, automation, and engineering-driven efficiency",
  },
  {
    slug: "/cells/management-excellence",
    name: "Management Excellence Cell",
    icon: "ri-team-line",
    description: "Organizational transformation and leadership capacity",
  },
  {
    slug: "/cells/textile-processing",
    name: "Textile Processing Cell",
    icon: "ri-drop-line",
    description: "Dyeing, finishing, and sustainable processing innovation",
  },
  {
    slug: "/cells/textile-materials",
    name: "Textile Materials Cell",
    icon: "ri-stack-line",
    description: "New fibers, blended materials, and waste recycling",
  },
  {
    slug: "/cells/marketing-merchandising",
    name: "Marketing & Merchandising Cell",
    icon: "ri-shopping-cart-2-line",
    description: "Supply chain sync, costing, and market intelligence",
  },
  {
    slug: "/cells/textile-efficiency",
    name: "Textile Efficiency Cell",
    icon: "ri-speed-line",
    description: "Lean management, waste elimination, and flow optimization",
  },
];

export default function CellPathwayNav() {
  return (
    <section className="bg-tie-grey-light py-16 md:py-20">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal>
            <div className="text-center max-w-3xl mx-auto mb-8 md:mb-12">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-navy/10 mb-4 md:mb-5">
                <span className="text-xs font-semibold text-tie-navy uppercase tracking-wider">
                  / Explore Other Cells
                </span>
              </div>
              <h2 className="font-serif text-xl md:text-2xl lg:text-3xl font-bold text-tie-text-primary leading-tight">
                Six Specialised Innovation Cells
              </h2>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {cells.map((cell, index) => {
              const isActive = typeof window !== "undefined" && window.location.pathname === cell.slug;
              return (
                <ScrollReveal key={cell.slug} delay={index * 100}>
                  <Link
                    to={cell.slug}
                    className={`group block p-5 md:p-6 rounded-xl border transition-all duration-300 ${
                      isActive
                        ? "bg-tie-navy border-tie-navy text-white"
                        : "bg-white border-tie-grey-dark hover:border-tie-teal/30 hover:shadow-lg"
                    }`}
                  >
                    <div className="flex items-center gap-3 mb-3">
                      <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${isActive ? "bg-white/15" : "bg-tie-teal/10"}`}>
                        <i className={`${cell.icon} ${isActive ? "text-tie-teal-light" : "text-tie-teal"} text-lg`} />
                      </div>
                      <span className={`text-xs font-semibold uppercase tracking-wider ${isActive ? "text-white/60" : "text-tie-text-muted"}`}>
                        Cell
                      </span>
                    </div>
                    <h3 className={`text-base md:text-lg font-semibold mb-1 ${isActive ? "text-white" : "text-tie-text-primary"}`}>
                      {cell.name}
                    </h3>
                    <p className={`text-sm ${isActive ? "text-white/60" : "text-tie-text-secondary"}`}>
                      {cell.description}
                    </p>
                  </Link>
                </ScrollReveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}